export const importPixel = (url = '', parametersObject = {}) => {
  if (url) {
    let script = document.createElement('script');
    let parameters = '';
  
    const keysList = Object.keys(parametersObject);
  
    if (typeof parametersObject === 'object' && keysList.length) {
      parameters += '?';
  
      keysList.forEach((key, index) => {
        if (index !== 0) {
          parameters += '&';
        }
  
        parameters += `${key}=${parametersObject[key]}`;
      });
    }
  
    script.src = `${url}${parameters}`;
  
    document.body.appendChild(script);
  }
}


// WEBPACK FOOTER //
// ./src/modules/pixels/pixelsUtils.js